/**
 * 統一錯誤處理工具
 */

// 錯誤類型定義
export const ErrorTypes = {
  NETWORK: 'NETWORK',
  PERMISSION: 'PERMISSION',
  VALIDATION: 'VALIDATION',
  DATABASE: 'DATABASE',
  UNKNOWN: 'UNKNOWN'
};

// 錯誤處理函數
export const handleError = (error, context = '') => {
  console.error(`[${context}]`, error);

  let errorType = ErrorTypes.UNKNOWN;
  let userMessage = '發生未知錯誤，請稍後再試';

  // 判斷錯誤類型
  if (error.code === 'permission-denied' || error.code === 'PERMISSION_DENIED') {
    errorType = ErrorTypes.PERMISSION;
    userMessage = '權限不足，請確認您已登入管理系統';
  } else if (error.code === 'unavailable' || error.message?.includes('network') || error.message?.includes('Network')) {
    errorType = ErrorTypes.NETWORK;
    userMessage = '網路連線異常，請檢查網路連線後再試';
  } else if (error.code === 'failed-precondition' || error.message?.includes('database')) {
    errorType = ErrorTypes.DATABASE;
    userMessage = '資料庫服務暫時無法使用，請稍後再試';
  } else if (error.message?.includes('驗證') || error.message?.includes('驗證')) {
    errorType = ErrorTypes.VALIDATION;
    userMessage = error.message || '資料驗證失敗，請檢查輸入內容';
  }

  // 如果有自定義錯誤訊息，優先使用
  if (error.userMessage) {
    userMessage = error.userMessage;
  } else if (error.message && !error.message.includes('Firebase') && !error.message.includes('permission')) {
    // 如果錯誤訊息是中文或較友好的，直接使用
    if (/[\u4e00-\u9fa5]/.test(error.message)) {
      userMessage = error.message;
    }
  }

  // 顯示 Toast 通知
  if (window.showToast) {
    window.showToast(userMessage, 'error', 5000);
  } else {
    // 後備方案：使用 alert
    alert(userMessage);
  }

  return {
    type: errorType,
    message: userMessage,
    originalError: error
  };
};

// 成功訊息處理
export const handleSuccess = (message, duration = 3000) => {
  if (window.showToast) {
    window.showToast(message, 'success', duration);
  } else {
    alert(message);
  }
};

// 警告訊息處理
export const handleWarning = (message, duration = 3000) => {
  if (window.showToast) {
    window.showToast(message, 'warning', duration);
  } else {
    alert(message);
  }
};

// 資訊訊息處理
export const handleInfo = (message, duration = 3000) => {
  if (window.showToast) {
    window.showToast(message, 'info', duration);
  } else {
    alert(message);
  }
};

// 包裝異步函數，自動處理錯誤
export const withErrorHandling = (asyncFn, context = '') => {
  return async (...args) => {
    try {
      return await asyncFn(...args);
    } catch (error) {
      handleError(error, context);
      throw error; // 重新拋出錯誤，讓調用者可以處理
    }
  };
};
